import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import Configurator from "components/products/configurator";
import { store } from "configure-store";

function initializeApplication() {
  const configurator = document.getElementById("configurator");

  if (configurator) {
    ReactDOM.render(
      <Provider store={store}>
        <Configurator
          productId={configurator.getAttribute("product-id")}
          projectSlug={configurator.getAttribute("project-slug")}
          lineItemId={configurator.getAttribute("line-item-id")}
          clientId={configurator.getAttribute("client-id")}
        />
      </Provider>,
      configurator
    );
  }
}

if (document.readyState !== 'loading') {
  initializeApplication();
}

document.addEventListener('DOMContentLoaded', () => {
  initializeApplication();
});
